// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import {
  VCol,
  VRow,
} from 'vuetify/lib'

Vue.use(Vuetify, {
  components: {
    VCol,
    VRow,
  },
})

// Brand palette. Cool "ocean" hues carry the surfaces and links,
// the warm end of the spectrum is reserved for the full-spectrum band.
export const brand = {
  ink: '#06041A',
  surface: '#0E0A33',
  cyan: '#78F5F5',
  sky: '#4FA8F5',
  blue: '#2540F0',
  deep: '#1000E8',
  indigo: '#4B1DE8',
  violet: '#A81AE8',
  magenta: '#E83AF0',
  pink: '#E63BB0',
  mint: '#7FF5D8',
  green: '#6BF06B',
  red: '#E8404F',
  orange: '#E85A2E',
  yellow: '#F2C63B',
}

const theme = {
  primary: brand.cyan,
  secondary: brand.surface,
  accent: brand.magenta,
  info: brand.sky,
  success: brand.mint,
  warning: brand.yellow,
  error: brand.red,
  anchor: brand.cyan,
}

export default new Vuetify({
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      dark: { ...theme },
      light: { ...theme },
    },
  },
})
